import OrderInfoCard from "./OrderInfoCard";
import Reader from "./Reader";
import "./LeftStyle.scss";

const Left = () => (
  <div className="left-v3">
    <OrderInfoCard />
    <Reader />
  </div>
);

export default Left;
